module.exports = __webpack_public_path__ + "static/data_reports-2659547e42b0c3e2f141023bdf5d674e.svg";